import { useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { GROUP_USER } from '../../config/appGroupConfig';
import Navbar from '../Navbar';
import { VENUE_NAVBAR_MENU, VENDOR_NAVBAR_MENU, ADMIN_NAVBAR_MENU } from '../../constants/navbar';
import { getNotificationsByUser } from '../../core/notifications/action';

const NAVBAR_ITEMS = {
  [GROUP_USER.VENDOR]: VENDOR_NAVBAR_MENU,
  [GROUP_USER.VENUE]: VENUE_NAVBAR_MENU,
  [GROUP_USER.ADMIN]: ADMIN_NAVBAR_MENU,
};

export default function UserNavbar({ menuItem }) {
  const dispatch = useDispatch();
  const { user } = useSelector((store) => store.users);

  const itemsByRole = useMemo(
    () => (user?.role?.name ? NAVBAR_ITEMS[user?.role?.name] : []),
    // eslint-disable-next-line prettier/prettier
    [user]
  );

  useEffect(() => {
    const interval = setInterval(() => {
      if (process.env.REACT_APP_DISABLE_NOTIFICATIONS) return;
      if (!user?.id) return;
      dispatch(getNotificationsByUser(user.id));
    }, 5000);

    return () => {
      clearInterval(interval);
    };
  }, [dispatch, user]);
  return <Navbar elements={itemsByRole} menuItem={menuItem} />;
}

UserNavbar.propTypes = {
  menuItem: PropTypes.node,
};

UserNavbar.defaultProps = {
  menuItem: undefined,
};
